import {
  Contact,
  InputContactInfo,
  ShippingAddressController,
} from '@/controllers/ShippingAddress';
import { ContactVm, ReduxSagaAction } from '@/types';

import { ShippingAddressesActionTypes } from './action-types';

export const createNewShippingAddress = (
  shippingAddress: ContactVm | InputContactInfo,
): ReduxSagaAction => ({
  type: ShippingAddressesActionTypes.CREATE_NEW_SHIPPING_ADDRESS.START,
  subtypes: ShippingAddressesActionTypes.CREATE_NEW_SHIPPING_ADDRESS,
  sagaPayload: { shipmentInfo: shippingAddress },
  promise: () => ShippingAddressController.createNewShippingAddress(shippingAddress),
  onFail: error => console.error(error),
});

export const fetchShippingAddresses = (): ReduxSagaAction => ({
  type: ShippingAddressesActionTypes.FETCH_SHIPPING_ADDRESSES.START,
  subtypes: ShippingAddressesActionTypes.FETCH_SHIPPING_ADDRESSES,
  promise: ShippingAddressController.fetchShippingAddresses,
});

export const updateShippingAddresses = (newShipmentInfo: Contact | ContactVm): ReduxSagaAction => ({
  type: ShippingAddressesActionTypes.UPDATE_SHIPPING_ADDRESS.START,
  subtypes: ShippingAddressesActionTypes.UPDATE_SHIPPING_ADDRESS,
  sagaPayload: { newShipmentInfo },
  promise: () => {
    return ShippingAddressController.updateShippingAddresses(newShipmentInfo);
  },
  onFail: error => console.error(error),
});

export const deleteShippingAddresses = (shipmentAddressId: string): ReduxSagaAction => ({
  type: ShippingAddressesActionTypes.DELETE_SHIPPING_ADDRESS.START,
  subtypes: ShippingAddressesActionTypes.DELETE_SHIPPING_ADDRESS,
  promise: () => ShippingAddressController.deleteShippingAddresses(shipmentAddressId),
  onFail: error => console.error(error),
});
